/**
 * ENGAGE-SIZING-1 — industry verticals offered at engagement intake.
 *
 * SOURCE OF TRUTH is `INDUSTRY_MULTIPLES` in `core/qoe/industry_benchmarks.py`.
 * These strings are matched against that dict by exact key first, then by a
 * fuzzy contains-check, and anything unrecognized degrades to
 * "Other / General SMB" — so a drift between this list and the backend costs a
 * tailored benchmark, never a failed deal creation.
 *
 * The same value also drives the industry overlay on the seller document
 * request list (`core/qoe/document_requests.py`), which is why it is worth
 * asking for at intake rather than inferring later.
 */

export const OTHER_VERTICAL = 'Other / General SMB'

export const VERTICALS: readonly string[] = [
  'HVAC / Mechanical Contractors',
  'Construction / General Contractor',
  'Manufacturing (Job Shop)',
  'Trucking / Freight',
  'Auto Repair',
  'Landscaping / Lawn Care',
  'Restaurant / QSR',
  'E-Commerce / Online Retail',
  'IT / Managed Services (MSP)',
  'Accounting / Tax / CPA Firm',
  'Professional Services (General)',
  'Staffing Agency',
  'Insurance Agency',
  'Real Estate Brokerage',
  'Dental Practice',
  'Healthcare (Home Health)',
  'Physical Therapy / Outpatient',
  'Childcare / Daycare',
  'Fitness / Gym',
  OTHER_VERTICAL,
]
